// FAMILY-EXT: персист фильтров доски между F5 (localStorage).
//
// Стратегия:
// 1. После каждого изменения фильтра (USER_TO_BOARD_FILTER_ADD,
//    LABEL_TO_BOARD_FILTER_ADD, TEXT_FILTER_IN_CURRENT_BOARD,
//    BOARD_TOGGLE_SHOW_HIDDEN, BOARD_TOGGLE_SHOW_ONLY_ACTIVE и
//    соответствующих REMOVE) — собираем текущее состояние фильтров
//    из orm и пишем в localStorage по ключу board:boardId.
// 2. После BOARD_FETCH__SUCCESS (доска загружена) — читаем localStorage
//    и диспатчим BOARD_FILTERS_RESTORE, чтобы вернуть фильтры в orm.

import { all, takeEvery, select, put, delay } from 'redux-saga/effects';

import ActionTypes from '../../../constants/ActionTypes';
import actions from '../../../actions';
import selectors from '../../../selectors';
import {
  loadBoardFilters,
  saveBoardFilters,
} from '../../../utils/family-filter-storage';

function* saveFiltersForCurrentBoard() {
  const path = yield select(selectors.selectPath);
  const boardId = path && path.boardId;
  if (!boardId) return;

  const filterUsers = yield select(selectors.selectFilterUsersForCurrentBoard);
  const filterLabels = yield select(selectors.selectFilterLabelsForCurrentBoard);
  const filterText = yield select(selectors.selectFilterTextForCurrentBoard);
  const showHiddenCards = yield select(selectors.selectShowHiddenForCurrentBoard);
  const showOnlyActive = yield select(selectors.selectShowOnlyActiveForCurrentBoard);

  saveBoardFilters(boardId, {
    filterUserIds: (filterUsers || []).map((u) => u.id),
    filterLabelIds: (filterLabels || []).map((l) => l.id),
    filterText: filterText || '',
    showHiddenCards: showHiddenCards || 'no',
    showOnlyActive: !!showOnlyActive,
  });
}

// Дебаунс для filterText (текст печатается посимвольно — не нужно бить
// localStorage на каждую букву).
function* saveFiltersDebounced() {
  yield delay(250);
  yield* saveFiltersForCurrentBoard();
}

function* restoreFiltersForBoard(boardId) {
  if (!boardId) return;
  const data = loadBoardFilters(boardId);
  if (!data) return;
  yield put(actions.restoreBoardFilters(boardId, data));
}

export default function* familyFiltersWatchers() {
  yield all([
    // Сохраняем после каждого filter-change action.
    takeEvery(
      [
        ActionTypes.USER_TO_BOARD_FILTER_ADD,
        ActionTypes.USER_FROM_BOARD_FILTER_REMOVE,
        ActionTypes.LABEL_TO_BOARD_FILTER_ADD,
        ActionTypes.LABEL_FROM_BOARD_FILTER_REMOVE,
        ActionTypes.BOARD_TOGGLE_SHOW_HIDDEN,
        ActionTypes.BOARD_TOGGLE_SHOW_ONLY_ACTIVE,
      ],
      saveFiltersForCurrentBoard,
    ),
    // Текстовый фильтр — с дебаунсом.
    takeEvery(ActionTypes.TEXT_FILTER_IN_CURRENT_BOARD, saveFiltersDebounced),
    // Восстанавливаем при загрузке доски через BOARD_FETCH (явный
    // запрос доски).
    takeEvery(ActionTypes.BOARD_FETCH__SUCCESS, function* onBoardFetched({ payload }) {
      yield* restoreFiltersForBoard(payload.board && payload.board.id);
    }),
    // Восстанавливаем при изменении URL (переход на доску или F5).
    // LOCATION_CHANGE_HANDLE имеет payload.board когда в URL есть boardId.
    takeEvery(ActionTypes.LOCATION_CHANGE_HANDLE, function* onLocationChange({ payload }) {
      const boardId = payload && payload.board && payload.board.id;
      if (boardId) {
        yield* restoreFiltersForBoard(boardId);
      }
    }),
    // На самом начальном fetch (cold start приложения).
    takeEvery(ActionTypes.CORE_INITIALIZE, function* onCoreInit({ payload }) {
      const boardId = payload && payload.board && payload.board.id;
      if (boardId) {
        yield* restoreFiltersForBoard(boardId);
      }
    }),
  ]);
}
